export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_PARTNER = 'ROLE_PARTNER';
